import debug from 'debug';

export const getLogger = (ns: string) => {
  const logger = debug(ns);
  return (...args: unknown[]) => {
    return logger(ns, ...args);
  };
};
